// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================
   AssetsPage Styles
   Uses CSS variables from colors.css — flat surfaces, no gradients
   ====================== */

.assets-page-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  padding: 32px 36px;
  overflow-y: auto;
  box-sizing: border-box;
  background: var(--color-bg-root);
}

/* Header */
.assets-page-header-section {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.assets-page-header-left {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.assets-page-title {
  font-size: 22px;
  font-weight: 700;
  color: var(--color-text-primary);
  margin: 0;
  letter-spacing: -0.3px;
}

.assets-page-subtitle {
  font-size: 13px;
  color: var(--color-text-secondary);
  margin: 0;
}

.assets-page-new-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 4px;
  border: 1px solid var(--color-text-primary);
  background: var(--color-text-primary);
  color: var(--color-bg-canvas-surface);
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: opacity 0.15s ease;
  white-space: nowrap;
  flex-shrink: 0;
}

.assets-page-new-button:hover:not(:disabled) {
  opacity: 0.88;
}

.assets-page-new-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Dropdown */
.assets-page-dropdown {
  min-width: 180px;
  background: var(--color-bg-sidebar);
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  padding: 4px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  z-index: 100;
}

.assets-page-dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 3px;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  color: var(--color-text-secondary);
  cursor: pointer;
  outline: none;
  transition: background 0.1s ease, color 0.1s ease;
}

.assets-page-dropdown-item:hover,
.assets-page-dropdown-item[data-highlighted] {
  background: var(--color-bg-input);
  color: var(--color-text-primary);
}

/* Search */
.assets-page-search-row {
  margin-bottom: 20px;
}

.assets-page-search {
  width: 100%;
  max-width: 340px;
  padding: 8px 12px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 13px;
  font-family: inherit;
  box-sizing: border-box;
  transition: border-color 0.15s ease;
}

.assets-page-search:focus {
  outline: none;
  border-color: var(--color-text-secondary);
}

.assets-page-search::placeholder {
  color: var(--color-text-secondary);
}

/* Error */
.assets-page-error {
  padding: 10px 14px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: rgba(220, 38, 38, 0.08);
  color: #dc2626;
  font-size: 13px;
  margin-bottom: 16px;
}

/* Loading */
.assets-page-loading {
  color: var(--color-text-secondary);
  font-size: 13px;
  padding: 40px 0;
  text-align: center;
}

/* Empty state */
.assets-page-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 80px 24px;
  text-align: center;
  color: var(--color-text-secondary);
}

.assets-page-empty-icon {
  opacity: 0.3;
  margin-bottom: 4px;
}

.assets-page-empty p {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
}

.assets-page-empty-hint {
  font-size: 13px !important;
  font-weight: 400 !important;
  opacity: 0.7;
}

.assets-page-empty-cta {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  padding: 9px 16px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.assets-page-empty-cta:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

/* Grid */
.assets-page-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px;
}

/* Asset card */
.assets-page-grid .asset-card {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  overflow: hidden;
  background: var(--color-bg-sidebar);
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  /* Override the global fade-in/stagger from EditorPage.css — cached cards should appear instantly. */
  animation: none;
}

.assets-page-grid .asset-card:nth-child(n) {
  animation-delay: 0s;
}

.asset-card:hover {
  border-color: var(--color-text-secondary);
}

.asset-card:focus {
  outline: 2px solid var(--color-focus-ring);
  outline-offset: 1px;
}

.asset-card-image-wrapper {
  position: relative;
  width: 100%;
  aspect-ratio: 1;
  background: var(--color-bg-canvas-surface);
  overflow: hidden;
}

.asset-card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.asset-card-image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-secondary);
  opacity: 0.35;
}

.asset-card-sub-badge {
  position: absolute;
  top: 6px;
  right: 6px;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 6px;
  border-radius: 3px;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  color: var(--color-text-secondary);
  font-size: 10px;
  font-weight: 600;
}

.asset-card-info {
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.asset-card-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.asset-card-prompt {
  font-size: 11px;
  color: var(--color-text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Create wrapper (full-page generation view) */
.assets-page-create-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 24px;
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/AssetsPage.css"],"names":[],"mappings":"AAAA;;;2BAG2B;;AAE3B;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,mCAAmC;EACnC,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;EAClC,eAAe;EACf,aAAa;EACb,iDAAiD;AACnD;;AAEA;;EAEE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;AACpC;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA,SAAS;AACT;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;EACf,0DAA0D;EAC1D,oGAAoG;EACpG,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,2CAA2C;EAC3C,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB","sourcesContent":["/* ======================\n   AssetsPage Styles\n   Uses CSS variables from colors.css — flat surfaces, no gradients\n   ====================== */\n\n.assets-page-content {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n  padding: 32px 36px;\n  overflow-y: auto;\n  box-sizing: border-box;\n  background: var(--color-bg-root);\n}\n\n/* Header */\n.assets-page-header-section {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n}\n\n.assets-page-header-left {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.assets-page-title {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--color-text-primary);\n  margin: 0;\n  letter-spacing: -0.3px;\n}\n\n.assets-page-subtitle {\n  font-size: 13px;\n  color: var(--color-text-secondary);\n  margin: 0;\n}\n\n.assets-page-new-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border-radius: 4px;\n  border: 1px solid var(--color-text-primary);\n  background: var(--color-text-primary);\n  color: var(--color-bg-canvas-surface);\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: opacity 0.15s ease;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.assets-page-new-button:hover:not(:disabled) {\n  opacity: 0.88;\n}\n\n.assets-page-new-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Dropdown */\n.assets-page-dropdown {\n  min-width: 180px;\n  background: var(--color-bg-sidebar);\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  padding: 4px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n  z-index: 100;\n}\n\n.assets-page-dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border-radius: 3px;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: inherit;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  outline: none;\n  transition: background 0.1s ease, color 0.1s ease;\n}\n\n.assets-page-dropdown-item:hover,\n.assets-page-dropdown-item[data-highlighted] {\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n}\n\n/* Search */\n.assets-page-search-row {\n  margin-bottom: 20px;\n}\n\n.assets-page-search {\n  width: 100%;\n  max-width: 340px;\n  padding: 8px 12px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 13px;\n  font-family: inherit;\n  box-sizing: border-box;\n  transition: border-color 0.15s ease;\n}\n\n.assets-page-search:focus {\n  outline: none;\n  border-color: var(--color-text-secondary);\n}\n\n.assets-page-search::placeholder {\n  color: var(--color-text-secondary);\n}\n\n/* Error */\n.assets-page-error {\n  padding: 10px 14px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: rgba(220, 38, 38, 0.08);\n  color: #dc2626;\n  font-size: 13px;\n  margin-bottom: 16px;\n}\n\n/* Loading */\n.assets-page-loading {\n  color: var(--color-text-secondary);\n  font-size: 13px;\n  padding: 40px 0;\n  text-align: center;\n}\n\n/* Empty state */\n.assets-page-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 80px 24px;\n  text-align: center;\n  color: var(--color-text-secondary);\n}\n\n.assets-page-empty-icon {\n  opacity: 0.3;\n  margin-bottom: 4px;\n}\n\n.assets-page-empty p {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.assets-page-empty-hint {\n  font-size: 13px !important;\n  font-weight: 400 !important;\n  opacity: 0.7;\n}\n\n.assets-page-empty-cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 8px;\n  padding: 9px 16px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.assets-page-empty-cta:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n/* Grid */\n.assets-page-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 12px;\n}\n\n/* Asset card */\n.assets-page-grid .asset-card {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  overflow: hidden;\n  background: var(--color-bg-sidebar);\n  cursor: pointer;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  /* Override the global fade-in/stagger from EditorPage.css — cached cards should appear instantly. */\n  animation: none;\n}\n\n.assets-page-grid .asset-card:nth-child(n) {\n  animation-delay: 0s;\n}\n\n.asset-card:hover {\n  border-color: var(--color-text-secondary);\n}\n\n.asset-card:focus {\n  outline: 2px solid var(--color-focus-ring);\n  outline-offset: 1px;\n}\n\n.asset-card-image-wrapper {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 1;\n  background: var(--color-bg-canvas-surface);\n  overflow: hidden;\n}\n\n.asset-card-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.asset-card-image-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-text-secondary);\n  opacity: 0.35;\n}\n\n.asset-card-sub-badge {\n  position: absolute;\n  top: 6px;\n  right: 6px;\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  padding: 2px 6px;\n  border-radius: 3px;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  color: var(--color-text-secondary);\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.asset-card-info {\n  padding: 10px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.asset-card-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.asset-card-prompt {\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Create wrapper (full-page generation view) */\n.assets-page-create-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  padding: 24px;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
